import React, { Component } from 'react';
import _ from 'lodash';
import Joi from 'joi-browser';
import moment from 'moment';

import {
  FormElement,
  FormListItem,
  FormListSubHeader,
} from './CommonFormComponents';
import { CompanyOtherIndustryLicenseForm } from './forms/CompanyOtherIndustryLicenseForm';
import { CompanyOtherIndustryLicenseTable } from './tables/CompanyOtherIndustryLicenseTable';
import { RadioButtonIcon } from './icons/RadioButtonIcon';
import { ErrorIcon } from './icons/ErrorIcon';
import { Confirmation } from './modals/common';
import { Description } from './Description';
import {
  ATTACH_DOCUMENT_TYPE_COMPANY,
  EXISTANCE_FLAG,
  PERMISSION_GROUP_TYPE,
  SECURITY_INDUSTRY_NAME,
} from '../utilities/constants';
import { validationRegexByJoi } from '../utilities/commonValidation';
import regex from '../utilities/validateRegex';
import {
  attachDocumentCompanyUploadState,
  attachDocumentDeleteState,
} from '../utilities/attachDocumentUtil';
import {
  stringToDate,
  getMessageValidate,
  convertDate,
} from '../utilities/validateDateUtil';
import { localizeMessage } from '../utilities/validateMessage';
import { messageUtility } from '../utilities/messageUtility';

const OTHER_INDUSTRY_LICENSE_DEFAULT = {
  authorized_industry_names: '',
  permission_number_r: '',
  license_update_date: '//',
  license_limit_date: '//',
  company_documents: [],
  permission_group_type: PERMISSION_GROUP_TYPE.other,
};

export class CompanyOtherIndustryLicenseInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleFormDialog: false,
      formMode: null,
      editId: null,
      formValues: _.cloneDeep(OTHER_INDUSTRY_LICENSE_DEFAULT),
      validate: {
        messages: {},
        invalid: true,
      },
      warningMsg: {
        license_limit_date: '',
      },
    };
    this.formEvents = {
      handleOnChange: this.handleOnChange,
      handleValidate: this.handleValidate,
    };
    this.attachmentEvens = {
      uploadFile: this.uploadFile,
      deleteFile: this.deleteFile,
    };

    this.formSchema = Joi.object().keys({
      authorized_industry_names: Joi.string()
        .required()
        .max(40),
      permission_number_r: Joi.string()
        .required()
        .max(20)
        .regex(regex.pattern.integerNoSign)
        .label('integerNoSign'),
      license_update_date: Joi.string().required(),
      license_limit_date: Joi.string(),
      company_documents: Joi.any(),
    });

    this.periodFields = ['license_update_date', 'license_limit_date'];
  }

  uploadFile = (file, typeL, typeS) => {
    attachDocumentCompanyUploadState(
      this.state.formValues.company_documents,
      documents => {
        this.handleOnChange(documents, 'company_documents', () =>
          this.formEvents.handleValidate('company_documents')
        );
      },
      this.props.selectedCompanyId,
      file,
      typeL,
      typeS
    );
  };

  deleteFile = file => {
    attachDocumentDeleteState(
      this.state.formValues.company_documents,
      documents => {
        this.handleOnChange(documents, 'company_documents', () =>
          this.formEvents.handleValidate('company_documents')
        );
      },
      file
    );
  };

  downloadFile = fileId => {
    const { onDownloadFile } = this.props;
    if (_.isFunction(onDownloadFile)) {
      onDownloadFile(fileId);
    }
  };

  toggleFormDialog = (status, modeForm = null, callback) => {
    this.setState(
      {
        visibleFormDialog: status,
        modeForm,
      },
      callback
    );
  };

  /**
   * Update permission flag
   * @param {object} event: event input
   */
  updatePermissionFlag = event => {
    this.props.events.setFormValue('company_detail', event);
  };

  handleOnChangePermissionFlag = event => {
    const {
      values: { other_company_branch_permission_groups: permissionGroups },
      events: { handleDeletePermissionExistGreenFile },
    } = this.props;
    if (
      Number(event.target.value) === EXISTANCE_FLAG.NOEXIST.VALUE &&
      _.isFunction(handleDeletePermissionExistGreenFile)
    ) {
      event.persist();
      const idsToDelete = _.filter(
        permissionGroups,
        group => !group.isCreate
      ).map(group => group.company_branch_permission_id);
      handleDeletePermissionExistGreenFile(idsToDelete, () =>
        this.updatePermissionFlag(event)
      );
    } else {
      this.updatePermissionFlag(event);
    }
  };

  handleOnChange = (value, name, callback = null) => {
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          [name]: value,
        },
      },
      callback
    );
  };

  validateRequiredDate = value => {
    const [year, month, day] = stringToDate(value);
    if (!year && !month && !day) {
      return {
        status: false,
        message: localizeMessage.required,
      };
    }
    const errorMessage = getMessageValidate(year, month, day);
    if (errorMessage) {
      return {
        status: false,
        message: errorMessage,
      };
    }
    return {
      status: true,
    };
  };

  validateLimitDate = value => {
    this.setState({
      warningMsg: {
        ...this.state.warningMsg,
        license_limit_date: '',
      },
    });
    const [year, month, day] = stringToDate(value);
    const errorMessage = getMessageValidate(year, month, day);
    if (errorMessage) {
      return {
        status: false,
        message: errorMessage,
      };
    }
    const isBeforeCurrentDate = moment(value).isBefore(moment(), 'day');
    let warningLicenseLimitDate = '';
    if (
      this.hasDateValue(value) &&
      isBeforeCurrentDate &&
      !_.get(this.state.validate.messages, 'license_limit_date')
    ) {
      warningLicenseLimitDate = messageUtility.getMessage(
        'W-000-010',
        '許可',
        '許可（更新）年月日、有効期限年月日、添付書類'
      );
    }
    this.setState({
      warningMsg: {
        ...this.state.warningMsg,
        license_limit_date: warningLicenseLimitDate,
      },
    });
    return {
      status: true,
    };
  };

  validateLicensePeriod = formValues => {
    const { license_update_date, license_limit_date } = formValues;
    const updateDate = moment(license_update_date);
    const limitDate = moment(license_limit_date);
    if (updateDate.isAfter(limitDate)) {
      this.setState({
        warningMsg: {
          ...this.state.warningMsg,
          license_limit_date: '',
        },
      });
      return {
        status: false,
        messages: {
          license_update_date:
            '許可（更新）年月日が有効期限年月日より後の日付になっています。',
          license_limit_date:
            '有効期限年月日が許可（更新）年月日より後の日付になっています。',
        },
      };
    }
    return {
      status: true,
    };
  };

  validateIndustryNameDuplicate = value => {
    const { constructionIndustries } = this.props;
    const invalid =
      _.some(constructionIndustries, {
        construct_permit_industry_type_name: value,
      }) || value === SECURITY_INDUSTRY_NAME;
    return invalid
      ? { status: false, message: '許可業種の指定が誤っています。' }
      : { status: true };
  };

  hasDateValue = date => {
    const [year, month, day] = stringToDate(date);
    return year || month || day;
  };

  validate = (values, name, oldValidate) => {
    const newValidate = _.cloneDeep(oldValidate);
    const result = validationRegexByJoi(this.formSchema, values, true);
    const {
      license_update_date: licenseUpdateDate,
      license_limit_date: licenseDueDate,
      authorized_industry_names: licenseIndustryName,
    } = values;

    if (!result.messages.authorized_industry_names) {
      const industryNameValid = this.validateIndustryNameDuplicate(
        licenseIndustryName
      );
      if (!industryNameValid.status) {
        result.messages['authorized_industry_names'] =
          industryNameValid.message;
      }
    }

    if (!result.messages['license_update_date']) {
      const updateDateValid = this.validateRequiredDate(licenseUpdateDate);
      if (!updateDateValid.status) {
        result.messages['license_update_date'] = updateDateValid.message;
      }
    }

    if (!result.messages['license_limit_date']) {
      const limitDateValid = this.validateLimitDate(licenseDueDate);
      if (!limitDateValid.status) {
        result.messages['license_limit_date'] = limitDateValid.message;
      }
    }

    if (name) {
      if (result.messages[name]) {
        newValidate.messages[name] = result.messages[name];
      } else {
        newValidate.messages = _.omit(newValidate.messages, [name]);
      }
    } else {
      newValidate.messages = result.messages;
    }

    if (
      (!name || _.includes(this.periodFields, name)) &&
      _.every(this.periodFields, field => !_.has(result.messages, field)) &&
      _.every(this.periodFields, field => this.hasDateValue(values[field]))
    ) {
      const validatePeriod = this.validateLicensePeriod(values);
      if (!validatePeriod.status) {
        result.messages = {
          ...result.messages,
          ...validatePeriod.messages,
        };
        _.forEach(this.periodFields, field => {
          newValidate.messages[field] = result.messages[field];
        });
      } else {
        newValidate.messages = _.omit(newValidate.messages, this.periodFields);
      }
    } else if (
      (!name || name === 'license_limit_date') &&
      _.has(result.messages, 'license_limit_date') &&
      !_.has(result.messages, 'license_update_date')
    ) {
      newValidate.messages = _.omit(newValidate.messages, [
        'license_update_date',
      ]);
    }

    newValidate.invalid = !_.isEmpty(newValidate.messages);
    const attachmentFiles = values.company_documents;
    const attachmentInvalid = _.some(
      attachmentFiles,
      ({ invalidSize, invalidType, invalidName }) => invalidSize || invalidType || invalidName
    );
    newValidate.invalid = newValidate.invalid || attachmentInvalid;
    return newValidate;
  };

  handleValidate = name => {
    if (!name) {
      return;
    }
    const { formValues, validate } = this.state;
    const newValidate = this.validate(formValues, name, validate);
    this.setState({
      validate: newValidate,
    });
  };

  handleValidateAll = () => {
    const { formValues, validate } = this.state;
    const newValidate = this.validate(formValues, null, validate);
    this.setState({
      validate: newValidate,
    });
    return !newValidate.invalid;
  };

  handleSubmitForm = () => {
    const valid = this.handleValidateAll();
    if (!valid) {
      return;
    }

    const { formValues, modeForm, editId } = this.state;
    this.toggleFormDialog(false);
    if (modeForm === 'edit') {
      this.editLicense(editId, formValues);
    } else {
      this.createLicense(formValues);
    }
  };

  isHasOtherIndustryPermission = () => {
    const { values } = this.props;
    return (
      Number(_.get(values, 'company_detail.other_industry_permission_flag')) ===
      EXISTANCE_FLAG.EXIST.VALUE
    );
  };

  renderOtherIndustryPermission = () => {
    const { readOnly, values } = this.props;
    return (
      <FormListItem label='その他許可有無' required={!readOnly}>
        <FormElement>
          <div className='form-list-radio'>
            {_.map(EXISTANCE_FLAG, item => {
              const formValue = Number(
                _.get(values, 'company_detail.other_industry_permission_flag')
              );
              return readOnly ? (
                formValue === item.VALUE && (
                  <span key={item.VALUE}>{item.TEXT}</span>
                )
              ) : (
                <div className='form-list-radio__item' key={item.VALUE}>
                  <label className='radio'>
                    <input
                      type='radio'
                      id={`form-radio-other_industry_permission_flag-${
                        item.ID
                      }`}
                      value={item.VALUE}
                      name='other_industry_permission_flag'
                      checked={formValue === item.VALUE}
                      onChange={e => this.handleOnChangePermissionFlag(e)}
                    />
                    <RadioButtonIcon className='icon--2x' />
                    <span>{item.TEXT}</span>
                  </label>
                </div>
              );
            })}
          </div>
        </FormElement>
      </FormListItem>
    );
  };

  renderButtonCreate = () => {
    const { readOnly } = this.props;
    const { visibleFormDialog } = this.state;
    return (
      this.isHasOtherIndustryPermission() &&
      !readOnly && (
        <FormListItem>
          <button
            className={visibleFormDialog ? 'btn--disabled' : 'btn--sub'}
            onClick={() =>
              !this.state.visibleFormDialog && this.handleOpenCreateForm()
            }
          >
            許可情報を追加
          </button>
        </FormListItem>
      )
    );
  };

  renderTable = documentCodes => {
    const { values, checkboxList, readOnly } = this.props;
    return (
      this.isHasOtherIndustryPermission() && (
        <React.Fragment>
          {!readOnly && (
            <FormListItem label='許可情報' required={true} isBorder={false} />
          )}
          <FormListItem
            className='form-list__item form-list__item-table'
            isBorder={false}
          >
            <CompanyOtherIndustryLicenseTable
              data={values.other_company_branch_permission_groups}
              constructPermitTypes={checkboxList.construct_permit_types}
              readOnly={readOnly}
              errorColumn={this.tableHasErrorRow()}
              onEdit={this.handleOpenEditForm}
              onDelete={this.deleteLicense}
              onDownloadFile={this.downloadFile}
              documentCodes={documentCodes}
            />
          </FormListItem>
        </React.Fragment>
      )
    );
  };

  tableHasErrorRow = () =>
    _.some(
      _.get(this.props.values, 'other_company_branch_permission_groups'),
      'invalid_flag'
    );

  renderDescription = () => {
    if (!this.tableHasErrorRow() || !this.isHasOtherIndustryPermission()) {
      return null;
    }

    return (
      <FormListItem className='form-list__item form-list__item-description'>
        <Description type='primary'>
          <ErrorIcon className='icon--1_4x form-list__error-icon' />
          が表示されている許可情報は登録内容に誤りがあります。
          正しい情報に変更してください。
        </Description>
      </FormListItem>
    );
  };

  handleOpenEditForm = data => {
    const editData = {
      ...data,
      authorized_industry_names: data['authorized_industry_names'] || '',
      permission_number_r: data['permission_number_r'] || '',
      license_update_date: data['license_update_date'] || '//',
      license_limit_date: data['license_limit_date'] || '//',
      company_documents: data['company_documents'] || [],
    };

    this.setState(
      {
        editId: data.id,
        formValues: editData,
        validate: {
          messages: {},
          invalid: true,
        },
      },
      () => {
        this.toggleFormDialog(true, 'edit');
        this.handleValidateAll();
      }
    );
  };

  handleOpenCreateForm = () => {
    this.setState(
      {
        formValues: _.cloneDeep(OTHER_INDUSTRY_LICENSE_DEFAULT),
        validate: {
          messages: {},
          invalid: false,
        },
        warningMsg: {
          ...this.state.warningMsg,
          license_limit_date: '',
        },
      },
      () => this.toggleFormDialog(true, 'create')
    );
  };

  convertSubmitLicenseData = data => {
    const formatData = _.clone(data);
    const { license_limit_date } = formatData;
    formatData['license_limit_date'] = this.hasDateValue(license_limit_date)
      ? license_limit_date
      : '';
    return formatData;
  };

  createLicense = data => {
    const createData = this.convertSubmitLicenseData(data);
    this.props.events.addOtherIndustryPermission(createData);
  };

  editLicense = (id, data) => {
    const editData = this.convertSubmitLicenseData(data);
    this.props.events.editOtherIndustryPermission(id, editData);
  };

  deleteLicense = data => {
    this.props.events.deleteOtherIndustryLicense(data.id);
  };

  render() {
    const { documentCodes } = this.props;
    const {
      visibleFormDialog,
      validate,
      formValues,
      modeForm,
      warningMsg,
    } = this.state;
    const isUpdateForm = modeForm === 'edit';
    const otherIndustryLicenseDocumentCodes = _.filter(
      documentCodes,
      document => {
        return (
          document.file_typeL ===
          ATTACH_DOCUMENT_TYPE_COMPANY.OTHER_INDUSTRY_PERMISSION
        );
      }
    );
    return (
      <div
        className='CompanyOtherIndustryLicenseInformation'
        id='CompanyOtherIndustryLicenseInformation'
      >
        <FormListSubHeader title='その他許可情報' />
        {this.renderDescription()}
        {this.renderOtherIndustryPermission()}
        {this.renderTable(otherIndustryLicenseDocumentCodes)}
        {this.renderButtonCreate()}
        <Confirmation
          title={isUpdateForm ? 'その他許可情報編集' : 'その他許可情報追加'}
          visible={visibleFormDialog}
          rootClassName='CompanyOtherIndustryLicenseInformationDialog'
          cancelButtonText={isUpdateForm ? '編集をやめる' : '追加をやめる'}
          confirmButtonText='決定'
          effectiveButtonClassName={
            validate.invalid ? 'btn--disabled' : 'btn--effective'
          }
          message={
            <CompanyOtherIndustryLicenseForm
              documentCodes={otherIndustryLicenseDocumentCodes}
              validate={validate}
              formValues={formValues}
              formEvents={this.formEvents}
              attachmentEvens={this.attachmentEvens}
              warningMsg={warningMsg}
            />
          }
          onCancel={() => this.toggleFormDialog(false)}
          onConfirm={() => this.handleSubmitForm()}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CompanyOtherIndustryLicenseInformation.jsx